import { INIT_LOGGED_IN, SET_LOADER_ON, SET_LOADER_OFF } from "./actionTypes";

export const setLoggedIn = () => {
  return (dispatch, getstate) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: INIT_LOGGED_IN });
      resolve();
    });
  };
};

export const setLoaderOn = () => {
  return (dispatch, getstate) => {
    dispatch({ type: SET_LOADER_ON });
  };
};

export const setLoaderOff = () => {
  return (dispatch, getstate) => {
    dispatch({ type: SET_LOADER_OFF });
  };
};
